export default {
  SET_IS_SHOWN: (state, value) => { state.isShown = value; },
  SET_EDIT_ID: (state, id) => { state.editId = id; },
  SET_PAGES_LIST: (state, pages) => { state.pagesList = pages; },
  SET_IS_PAGE_EDITABLE(state, page) {
    state.isPageEditable = page || {};
  },
  UPDATE_IS_PAGE_FIELD(state, {
    key, value,
  }) {
    if (!state.isPageEditable) state.isPageEditable = {};
    state.isPageEditable[key] = value;
  },
  UPDATE_TRANSLATION(state, {
    locale, field, value,
  }) {
    if (!state.isPageEditable.translations) state.isPageEditable.translations = {};
    if (!state.isPageEditable.translations[locale]) state.isPageEditable.translations[locale] = {};
    state.isPageEditable.translations[locale][field] = value;
  },
  RESET_EDITOR_STATE(state) {
    state.editId = null;
    state.isPageEditable = {};
    state.pagesList = [];
  },
};
